import React from 'react';
import { Helmet } from 'react-helmet';
import './DataDeletion.scss';

const DataDeletion = () => {
  return (
    <div className='data-deletion-page'>
      <Helmet>
        <link rel="canonical" href="https://marketingv8.co/data-deletion" />
        <title>Data Deletion Instructions - Marketing v8</title>
        <meta name="description" content="Instructions on how to request deletion of your personal data from Marketing v8." />
        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://marketingv8.co/data-deletion" />
        <meta property="og:title" content="Data Deletion Instructions - Marketing v8" />
        <meta property="og:description" content="Instructions on how to request deletion of your personal data from Marketing v8." />
        <meta property="og:image" content="https://marketingv8.co/logov8.png" />
      </Helmet>

      <div className='data-deletion-hero'>
        <h1>Data Deletion Instructions</h1>
      </div>

      <div className='data-deletion-content'>

        <p>
          If you have used any Marketing v8 services and would like to request the deletion of your personal data, you can do so at any time.
        </p>

        <h2>How to Request Data Deletion</h2>
        <p>
          To request the deletion of your personal data collected through our Facebook application or any other Marketing v8 service, please follow one of the options below:
        </p>
        <ol>
          <li>
            <strong>Send an email</strong> to <a href="mailto:office@marketingv8.co">office@marketingv8.co</a> with the subject line <em>"Data Deletion Request"</em>. Please include the email address or Facebook user ID associated with your account.
          </li>
          <li>
            <strong>Use our contact form</strong> available at <a href="https://marketingv8.co/contact">marketingv8.co/contact</a> and describe your request in the message field.
          </li>
        </ol>

        <h2>What Data We Store</h2>
        <p>
          When you interact with our Facebook application or use our services, we may collect and store the following data:
        </p>
        <ul>
          <li>Name and email address (if provided)</li>
          <li>Facebook user ID (for app authentication purposes)</li>
          <li>Messages and inquiries submitted through our contact forms</li>
          <li>Newsletter subscription status (if you have subscribed)</li>
        </ul>

        <h2>Processing Your Request</h2>
        <p>
          After receiving your data deletion request, we will:
        </p>
        <ul>
          <li>Confirm receipt of your request within 3 business days</li>
          <li>Delete your personal data from our systems within 30 days</li>
          <li>Send you a confirmation once the deletion is complete</li>
        </ul>

        <h2>Contact</h2>
        <p>
          If you have any questions about your data or this process, please contact us:
        </p>
        <p>
          <strong>Marketing V8 Sp. z o.o.</strong><br />
          ul. Rybacka 16, 83-200 Rokocin<br />
          NIP: 5922290210<br />
          Email: <a href="mailto:office@marketingv8.co">office@marketingv8.co</a>
        </p>

      </div>
    </div>
  );
};

export default DataDeletion;
